// @ts-strict-ignore
import { memo } from 'react'

import { CreatePrereservation } from '@/features/product/CreatePrereservation'

import { TProduct } from '@/shared/types/product-types'

import cl from './BottomControllerPrereservation.module.scss'

interface BottomControllerPrereservationProps {
	productData: TProduct
	type: 'regular' | 'wide' | 'wideOnMobile'
	price?: number
	buttonName?: string
}

export const BottomControllerPrereservation = memo((props: BottomControllerPrereservationProps) => {
	const { productData, type, buttonName } = props

	return (
		<>
			{/*<YandexBadgesClient price={price} cardType={type} />*/}
			<div className={cl[type]}>
				<CreatePrereservation data={productData} buttonName={buttonName} />
			</div>
		</>
	)
})
